import { Component, Input, OnInit } from '@angular/core';
import { CardToken, CardTokenQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import * as luxon from 'luxon';

@Component({
  selector: 'fgb-payment-button',
  templateUrl: './payment-button.component.html',
  styleUrl: './payment-button.component.scss',
})
export class PaymentButtonComponent implements OnInit {
  @Input() cardRouteURL: string = '/payment';
  cardToken$: Observable<CardToken | undefined>;

  constructor(private cardTokenQuery: CardTokenQuery) {}

  ngOnInit(): void {
    this.cardToken$ = this.cardTokenQuery.selectDefaultCard();
  }

  isExpiried(expiryDate: string) {
    if (!expiryDate) return false;
    const now = luxon.DateTime.utc();
    const expiriedDate = luxon.DateTime.fromISO(expiryDate);
    return now > expiriedDate;
  }
}
